import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {Step, StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {StancheckAnfrage} from "../anfrage/stancheck.anfrage";
import {StancheckRequestService} from "../services/request.service";
import {StancheckForm} from "../stancheck.form";

/**
 * Overwrite the Generic step component for the first section fo the stancheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-eingabe',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class EingabeStepComponent extends StepComponent implements OnInit {

  /**
   * (input) data of the user
   */
  anfrage: StancheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: StancheckForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'stancheck';

  hideHelpForSteps = [];

  /**
   * @inheritDoc
   */
  constructor(
    protected stepService: StepService,
    protected router: Router,
    protected requestService: StancheckRequestService,
    protected elementService: ElementService,
  ) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.anfrage = this.anfrage;

    this.formConfig.setStepComponent(this);
    this.formConfig.setData(this.anfrage.userInput);

    if (this.steps.currentStep && this.hideHelpForSteps.includes(this.steps.currentStep.name)) {
      this.hideHelp();
    }

    // update the previous step
    this.onStepUpdate();
  }

  /**
   * @inheritDoc
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * Return the next step from a step list
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if (this.anfrage?.userInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.userInput);
      // save the data again. In some case some fields are auto updated
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onSubmit() {
    super.onSubmit();

    if (this.form.valid === false) {
      // form is not valid, maybe form errors are shown. Scroll upwards
      this.elementService.scrollToElement(this.stepForm.nativeElement);
    }
  }

  /**
   * @inheritDoc
   */
  onStepUpdate() {
    super.onStepUpdate();
  }

}
